"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactResponsive = require("react-responsive");
function useIsMobile() {
  var mobileMaxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 576;
  return (0, _reactResponsive.useMediaQuery)({
    maxWidth: mobileMaxWidth
  });
}
var _default = useIsMobile;
exports["default"] = _default;
//# sourceMappingURL=useIsMobile.js.map